import {KeysMatching} from "@/types";
import {Checkbox} from "@mui/material";
import {RowDescriptorRenderProps} from "./types";
import {formCheckboxMargin} from "@/constants";
import {TextField} from "@dvrt/graphql-widgets";
import {UpdateUserData} from "@/api";

export const TextFieldInput = <FieldType extends KeysMatching<UpdateUserData, string>>(
    props: RowDescriptorRenderProps<FieldType>,
) => {
    const {field, form, disabled} = props;
    return (
        <TextField
            disabled={disabled}
            id={field}
            type="text"
            value={form.values[field]}
            onChange={(value) => form.updateValues({[field]: value})}
            errors={form.errorHelper.fieldErrors(field)}
        />
    );
};

export const CheckboxInput = <FieldType extends KeysMatching<UpdateUserData, boolean>>(
    props: RowDescriptorRenderProps<FieldType>,
) => {
    const {field, form, disabled} = props;
    const checked = form.values[field];
    return (
        <Checkbox
            disabled={disabled}
            id={field}
            checked={checked}
            onChange={(event) => form.updateValues({[field]: event.target.checked})}
            color="primary"
            style={{marginLeft: formCheckboxMargin}}
        />
    );
};
